<template>
  <section class="media defaultSectionMargins">
    <div class="container">
      <h2 v-text="data.title" />
  
      <FlickitySlider v-if="data.items && Object.keys(data.items).length" class="media__Slider" :options="flickityOptions" :with-progress="true">
        <div v-for="(item, index) in data.items" class="media__SliderItem">
          <Flare :srcset="item.image" size="both" width="800" height="600" crop="fill" :alt="item.image" />
          <div class="media__SliderItemCounter">{{ index + 1 }}</div>
          <h3 v-text="item.title" />
          <p v-text="item.lead" />
        </div>
      </FlickitySlider>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  })

  const flickityOptions = {
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    cellAlign: 'left',
  };
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_media.scss');
</style>